"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStringObj = exports.filterOptions = void 0;
// variable used to store all filters in
exports.filterOptions = {
    assetClass: [i18n("All")],
    region: [],
    equityStrategy: [],
    fixedIncomeStrategy: [],
    balancedStrategy: [],
    currency: [],
};
// variable storing all used strings in filtering against raw data
exports.filterStringObj = {
    assetClass: {
        all: i18n("All"),
        equity: i18n("Equity"),
        fixedIncome: i18n("Fixed Income"),
        balanced: i18n("Balanced"),
        commodity: i18n("Commodity"),
    },
    regions: {
        global: i18n("Global"),
        us: i18n("USA"),
        canada: i18n("Canada"),
        emergingMarkets: i18n("Emerging Markets"),
    },
    equityStrategy: {
        indexTracking: i18n("Index Tracking"),
        dividend: i18n("Dividend"),
        industry: i18n("Industry/Sector"),
        innovation: i18n("Innovation Theme"),
        esg: i18n("ESG Theme"),
        usListed: i18n("US Listed"),
        other: i18n("Other"),
    },
    fixedIncomeStrategy: {
        corporate: i18n("Corporate – Low Risk"),
        nonCorporate: i18n("Corporate – High Yield"),
        government: i18n("Mix of Government"),
    },
    balancedStrategy: {
        mediumLow: i18n("Low to Medium Equity"),
        high: i18n("High Equity"),
    },
    currency: {
        cad: "CAD",
        usd: "USD",
    },
};
//# sourceMappingURL=module.js.map